import React from 'react';
import ContactUs from '../../components/ContactUs/ContactUs';
import styles from './AboutPage.module.css';

const AboutPage: React.FC = () => {
  return (
    <div className={styles['about-page']}>
      <section className={styles['about-intro']}>
        <h1>About Christ Centered Baptist</h1>
      </section>

      <section className={styles['about-mission']}>
        <h2>Our Foundation</h2>
        <p>
          Welcome to Christ Centered Baptist. We are a Baptist ministry committed to honoring Jesus Christ in all we do.
          Our ministry is built on the foundation of Jesus Christ Himself, who is "the chief corner stone" (Ephesians 2:20).
          We strive to follow the pattern of the New Testament in our doctrine, practice, and ministry focus.
          Our desire is to glorify God by faithfully teaching His Word, reaching the lost with the Gospel,
          and helping believers grow in their faith and service to the Lord.
        </p>
      </section>

      <section className={styles['about-beliefs']}>
        <h2>Statement of Faith</h2>
        <div className={styles['beliefs-container']}>
          <div className={styles['belief-section']}>
            <h3>The Bible</h3>
            <p>
              We believe the Holy Bible (Old and New Testaments) is God's perfect Word. God guided the writers
              so that every word in the original manuscripts was exactly what He wanted. We believe God has
              preserved His Word for English speakers in the King James Version of the Bible. The Bible is our
              final authority for what we believe and how we live.
            </p>
            <p className={styles['scripture']}>
              "All scripture is given by inspiration of God, and is profitable for doctrine, for reproof, for
              correction, for instruction in righteousness." (2 Timothy 3:16)
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>God</h3>
            <p>
              We believe in one God who exists as three Persons—Father, Son, and Holy Spirit. These three are
              equal in every way while remaining distinct Persons. Each Person of the Trinity is fully God,
              sharing the same nature, power, and glory.
            </p>
            <p className={styles['scripture']}>
              "For there are three that bear record in heaven, the Father, the Word, and the Holy Ghost: and
              these three are one." (1 John 5:7)
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>Jesus Christ</h3>
            <p>
              We believe that Jesus Christ is God's eternal Son who became human without giving up His divine
              nature. He was conceived by the Holy Spirit and born of the virgin Mary, enabling Him to reveal
              God to us and provide salvation.
            </p>
            <p className={styles['scripture']}>
              "And the Word was made flesh, and dwelt among us, (and we beheld his glory, the glory as of the
              only begotten of the Father,) full of grace and truth." (John 1:14)
            </p>
            <p>
              We believe that Jesus Christ paid the full price for our sins through His death on the cross.
              When He died, He took our place and bore the punishment we deserved. His sacrifice fully satisfied
              God's justice and paid the debt for our sins. We believe that Christ's bodily resurrection from the
              dead proves that God accepted His sacrifice and guarantees our salvation when we put our faith in Him.
            </p>
            <p className={styles['scripture']}>
              "Moreover, brethren, I declare unto you the gospel which I preached unto you, which also ye have
              received, and wherein ye stand; By which also ye are saved, if ye keep in memory what I preached
              unto you, unless ye have believed in vain. For I delivered unto you first of all that which I also
              received, how that Christ died for our sins according to the scriptures; And that he was buried,
              and that he rose again the third day according to the scriptures." (1 Corinthians 15:1-4)
            </p>
          </div>

          <div className={styles['belief-section']}>
            <h3>Creation</h3>
            <p>
              We believe God directly created the universe, all spirit beings, humans, and animals in six literal
              days, as described in Genesis. We reject the theory of evolution. We believe God created humans in
              His image, but through Adam's sin, all people became sinful by nature and separated from God.
            </p>
            <p className={styles['scripture']}>
              "In the beginning God created the heaven and the earth." (Genesis 1:1)
            </p>
            <p className={styles['scripture']}>
              "Wherefore, as by one man sin entered into the world, and death by sin; and so death passed upon
              all men, for that all have sinned." (Romans 5:12)
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>Salvation</h3>
            <p>
              We believe that salvation comes through the Gospel as clearly defined in 1 Corinthians 15:1-4:
              "Moreover, brethren, I declare unto you the gospel which I preached unto you, which also ye have
              received, and wherein ye stand; By which also ye are saved, if ye keep in memory what I preached
              unto you, unless ye have believed in vain. For I delivered unto you first of all that which I also
              received, how that Christ died for our sins according to the scriptures; And that he was buried,
              and that he rose again the third day according to the scriptures."
            </p>
            <p>
              This Gospel - Christ's death for our sins, His burial, and His resurrection - is God's free gift
              offered to all people. Salvation cannot be earned through good works but is received by personally
              placing faith in Jesus Christ, whose blood was shed on the cross to forgive our sins.
            </p>
            <p className={styles['scripture']}>
              "For by grace are ye saved through faith; and that not of yourselves: it is the gift of God: Not
              of works, lest any man should boast." (Ephesians 2:8-9)
            </p>
            <p>
              We believe that all people are sinners by nature and by choice and are therefore under God's
              judgment. Those who turn from their sins and trust in Jesus Christ as Savior are born again by
              the Holy Spirit.
            </p>
            <p className={styles['scripture']}>
              "For all have sinned, and come short of the glory of God." (Romans 3:23)
            </p>
            <p className={styles['scripture']}>
              "Not by works of righteousness which we have done, but according to his mercy he saved us, by the
              washing of regeneration, and renewing of the Holy Ghost." (Titus 3:5)
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>Eternal Security</h3>
            <p>
              We believe that once a person is truly saved, they are kept secure by God's power and cannot lose
              their salvation. God preserves all true believers and ensures they remain saved forever.
            </p>
            <p className={styles['scripture']}>
              "And I give unto them eternal life; and they shall never perish, neither shall any man pluck them
              out of my hand." (John 10:28)
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>The Church</h3>
            <p>
              We believe that the local church is a group of baptized believers who gather regularly for Bible
              teaching, prayer, fellowship, and sharing the Gospel. The church serves as a spiritual school where
              believers grow from spiritual infancy to maturity through Bible teaching, mentoring, and discipleship.
              We practice baptism by immersion for believers only, which symbolizes our death to sin and new life
              in Christ.
            </p>
            <p className={styles['scripture']}>
              "Then they that gladly received his word were baptized: and the same day there were added unto them
              about three thousand souls." (Acts 2:41)
            </p>
            <p className={styles['scripture']}>
              "And he gave some, apostles; and some, prophets; and some, evangelists; and some, pastors and
              teachers; For the perfecting of the saints, for the work of the ministry, for the edifying of the
              body of Christ: Till we all come in the unity of the faith, and of the knowledge of the Son of God,
              unto a perfect man, unto the measure of the stature of the fulness of Christ." (Ephesians 4:11-13)
            </p>
            <p>
              Though we are not a church ourselves, we support and uphold the biblical role of the local church
              in the believer's life.
            </p>
          </div>
          
          <div className={styles['belief-section']}>
            <h3>The Return of Christ</h3>
            <p>
              We believe Jesus will physically return to earth to judge the living and the dead and to establish
              His thousand-year kingdom.
            </p>
            <p className={styles['scripture']}>
              "For the Lord himself shall descend from heaven with a shout, with the voice of the archangel, and
              with the trump of God: and the dead in Christ shall rise first: Then we which are alive and remain
              shall be caught up together with them in the clouds, to meet the Lord in the air: and so shall we
              ever be with the Lord." (1 Thessalonians 4:16-17)
            </p>
          </div>
        </div>
      </section>

      <section className={styles['about-content']}>
        <h2>Our Mission</h2>
        <p>
          Christ Centered Baptist exists to:
        </p>
        <ul className={styles['content-list']}>
          <li>Exalt the Savior - We aim to honor, reverence, and glorify the Lord Jesus Christ in all we do.</li>
          <li>Expound the Scriptures - We are committed to teaching sound Bible truth and training believers for Christian service.</li>
          <li>Evangelize the Sinner - We actively share the Gospel with the lost, both in our community and around the world.</li>
        </ul>
        <p>
          Our focus is on faithful Bible preaching, evangelistic outreach, missions support, and biblical discipleship.
          We hold to the historic Baptist beliefs and stand firmly on the fundamentals of the faith.
        </p>
      </section>

      <ContactUs />
    </div>
  );
};

export default AboutPage;
